module.exports = __webpack_public_path__ + "static/img/Frame 1859.ff64c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1859.png
// module id = O282
// module chunks = 12